import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';

/**
 * Router configuration for GTSS application
 * Implements client-side routing with Vue Router 4
 */
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'GTSS - Gorau Teachers Service Scheme'
    }
  },
  {
    path: '/registered-users',
    name: 'RegisteredUsers',
    component: () => import('../views/RegisteredUsersPage.vue'),
    meta: {
      title: 'Registered Users - GTSS'
    }
  },
  {
    // Catch-all route for 404 pages
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top when navigating to a new route
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

// Global navigation guard to update page titles
router.beforeEach((to, from, next) => {
  // Update document title based on route meta
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;